import { QueryClient } from '@tanstack/react-query';

// Shared TanStack Query client for the app. Conservative defaults suited to a
// foundation shell that tolerates an offline API.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});
